import { IModel } from "@/@types/models/model";
import { coreFields } from "./helpers/coreFields";
import { commonFields } from "./helpers/commonFields";

const Solari: IModel = {
  title: "Solari",
  apiPath: "data/Solari",
  forms: {
    "default": {
      fields: ["id", "zona", "snaga", "duzina_mm", "sirina_mm", "kc", "ko_mb", "ko_ime", "povrsina", "komentar"]
    }
  },
  listViews: {
    "default": {
      fields: ["id"]
    }
  },
  fields: [
    coreFields.id,
    commonFields.zona,
    commonFields.kc,
    commonFields.ko_mb,
    commonFields.ko_ime,
    commonFields.povrsina,
    {
      title: "snaga",
      source: "snaga",
      ttoken: "common.snaga",
      type: "wholenum",
      readonly: true
    },
    {
      title: "duzina_mm",
      source: "duzina_mm",
      ttoken: "common.duzina_mm",
      type: "wholenum",
      readonly: true
    },
    {
      title: "sirina_mm",
      source: "sirina_mm",
      ttoken: "common.sirina_mm",
      type: "wholenum",
      readonly: true
    },
    {
      title: "komentar",
      source: "komentar",
      ttoken: "common.komentar",
      type: "text",
      readonly: true
    }
  ]
}

export default Solari;